import { Separator } from '@/components/ui/separator';
import { Musikk } from '@/services/api';
import { useFilesTab } from './files-tab/hooks/useFilesTab';
import { MessageCard } from './files-tab/components/MessageCard';
import { ExistingFilesList } from './files-tab/components/ExistingFilesList';
import { AddFileForm } from './files-tab/components/AddFileForm';
import { DeleteFileDialog } from './files-tab/components/DeleteFileDialog';
import { FileInfoCard } from './files-tab/components/FileInfoCard';

interface Props {
  musikk: Musikk | null;
}

export default function FilesTab({ musikk }: Props) {
  const {
    navn,
    setNavn,
    filType,
    setFilType,
    selectedFile,
    setSelectedFile,
    url,
    setUrl,
    existingFiler,
    loading,
    uploadingId,
    successMessage,
    setSuccessMessage,
    errorMessage,
    setErrorMessage,
    errors,
    setErrors,
    deleteDialogOpen,
    setDeleteDialogOpen,
    fileToDelete,
    fileInputRef,
    handleFileChange,
    handleAddFile,
    handleDeleteFile,
    confirmDeleteFile,
    handleDownload,
  } = useFilesTab({ musikk });

  return (
    <div className="space-y-6">
      {successMessage && (
        <MessageCard
          type="success"
          message={successMessage}
          onDismiss={() => setSuccessMessage(null)}
        />
      )}

      {errorMessage && (
        <MessageCard
          type="error"
          message={errorMessage}
          onDismiss={() => setErrorMessage(null)}
        />
      )}

      <ExistingFilesList
        files={existingFiler}
        uploadingId={uploadingId}
        onDownload={handleDownload}
        onDelete={handleDeleteFile}
      />

      {existingFiler.length > 0 && <Separator />}

      <AddFileForm
        navn={navn}
        filType={filType}
        selectedFile={selectedFile}
        url={url}
        errors={errors}
        loading={loading}
        fileInputRef={fileInputRef}
        onNavnChange={setNavn}
        onFilTypeChange={(type) => {
          setFilType(type);
          if (type === 'upload') {
                      setUrl('');
          } else {
                      setSelectedFile(null);
            if (fileInputRef.current) {
              fileInputRef.current.value = '';
            }
          }
                      setErrors({});
                    }}
        onFileChange={handleFileChange}
        onUrlChange={setUrl}
        onRemoveFile={() => {
                        setSelectedFile(null);
                        if (fileInputRef.current) {
                          fileInputRef.current.value = '';
                        }
                      }}
        onSubmit={handleAddFile}
      />

      <FileInfoCard />

      <DeleteFileDialog
        open={deleteDialogOpen}
        fileToDelete={fileToDelete}
        onOpenChange={setDeleteDialogOpen}
        onConfirm={confirmDeleteFile}
      />
    </div>
  );
}
